import { Box, Grid, Typography, IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";

type DocumentKeyValueRowProps = {
    label: React.ReactNode;
    value: React.ReactNode;
    multiline?: boolean;
    labelCols?: number;
    valueCols?: number;
    editable?: boolean;
    onEdit?: () => void;
};

export const DocumentKeyValueRow = ({
    label,
    value,
    multiline = false,
    labelCols = 2,
    valueCols = 10,
    editable = false,
    onEdit,
}: DocumentKeyValueRowProps) => (
    <Grid
        container
        spacing={1.5}
        alignItems="stretch"
        sx={{
            py: 0.75,
            borderBottom: (t) => `1px dashed ${t.palette.divider}`,
            "&:last-of-type": { borderBottom: "none" },
        }}
    >
        {/* label */}
        <Grid item xs={12} sm={labelCols}>
            <Box
                sx={(t) => ({
                    bgcolor: t.palette.grey[100],
                    border: `1px solid ${t.palette.grey[200]}`,
                    borderRadius: 1,
                    px: 1,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                })}
            >
                <Typography variant="body2" fontWeight={600} color="text.secondary">{label}</Typography>

            </Box>
        </Grid>

        {/* value + ewentualny ołówek */}
        <Grid item xs={12} sm={valueCols} sx={{ minWidth: 0 }}>
            <Box
                sx={(t) => ({
                    border: `1px solid ${t.palette.grey[200]}`,
                    bgcolor: t.palette.grey[50],
                    borderRadius: 1,
                    px: 1.25,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    minWidth: 0,
                    overflow: "hidden",
                    alignItems: multiline ? "flex-start" : "center",
                    "& .rich :first-child": {
                        mt: 0,
                    },
                    "& .rich :last-child": {
                        mb: 0,
                    },
                })}
            >
                <Box sx={{ flex: "1 1 0", minWidth: 0, width: 0 }}>
                    <Typography
                        variant="body1"
                        fontWeight={600}
                        component="div"
                        sx={{
                            display: "block",
                            minWidth: 0,
                            maxWidth: "100%",
                            width: "100%",
                            ...(multiline
                                ? {
                                    whiteSpace: "pre-line",
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                }
                                : {
                                    display: "block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }),
                        }}
                    >
                        {value}
                    </Typography>
                </Box>

                {editable && onEdit && (
                    <IconButton
                        size="small"
                        onClick={onEdit}
                        sx={{ ml: 1 }}
                    >
                        <Edit fontSize="small" />
                    </IconButton>
                )}
            </Box>
        </Grid>
    </Grid>
);
